import React from 'react';
import Tooltip from '../../../generic_components/Tooltip/Tooltip';

const DeviceInfoIcon = ({ onClick, disabled, server, size = 20, isNInjaOffline }) => {
  // Check if there are any alerts
  const hasAlerts = (server?.ninjaDetail?.ninjaData?.alerts && server.ninjaDetail.ninjaData.alerts.length > 0);
  const isOffline = server?.ninjaDetail?.ninjaData?.offline;
  
  // Determine color based on alert status and disabled state
  const getIconColor = () => {
    if (disabled) return '#666'; // Gray for disabled
    
    if (hasAlerts) return '#FFA500'; // any device hardware alerts - Orange
    else if (isOffline) return '#C82333'; // Offline - Red
    else return '#22BE63'; // Normal - Green
  };

  const iconColor = getIconColor();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: 'none',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: '4px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.5 : 1,
      }}
    
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'transparent';
      }}
    >
      {/* Computer/Device Icon SVG */}
      <Tooltip 
        content={ 
        disabled ? 'No system data available' :
        isNInjaOffline ? 'Offline - Click for system details' :
        hasAlerts ? `${server.ninjaDetail.ninjaData.alerts.length} system alert(s) detected - Click for details` : 'Click for system details'}
        placement='top'
        >
        <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Monitor/Computer Icon */}
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
        
        {/* Alert indicator dot if there are alerts */}
        {hasAlerts && (
          <circle cx="19" cy="5" r="2" fill="#C82333" stroke="none" />
        )}
      </svg>     
        </Tooltip> 
     
    </button>
  );
};

// Alternative version with different icon styles
const DeviceInfoIconAlt = ({ onClick, disabled, server, size = 20, iconStyle = 'monitor' }) => {
  const hasAlerts = server?.ninjaDetail?.ninjaData?.alerts && server.ninjaDetail.ninjaData.alerts.length > 0;
  
  const getIconColor = () => {
    if (disabled) return '#666';
    return hasAlerts ? '#C82333' : '#22BE63'; // Red for any alerts, green for normal
  };

  const iconColor = getIconColor();

  const renderIcon = () => {
    switch (iconStyle) {
      case 'server':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2">
            <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
            <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
            <line x1="6" y1="6" x2="6.01" y2="6" />
            <line x1="6" y1="18" x2="6.01" y2="18" />
            {hasAlerts && <circle cx="19" cy="5" r="2" fill="#C82333" stroke="none" />}
          </svg>
        );
      
      case 'desktop':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2">
            <rect x="3" y="4" width="18" height="12" rx="1" />
            <line x1="2" y1="20" x2="22" y2="20" />
            <line x1="12" y1="16" x2="12" y2="20" />
            {hasAlerts && <circle cx="19" cy="6" r="2" fill="#C82333" stroke="none" />}
          </svg>
        );
      
      default: // monitor
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            {hasAlerts && <circle cx="19" cy="5" r="2" fill="#C82333" stroke="none" />}
          </svg>
        );
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: 'none',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: '4px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.5 : 1,
        position: 'relative',
      }}
      title=
        { 
          disabled ? 'No system data available' :
          hasAlerts ? `${server.ninjaDetail.ninjaData.alerts.length} system alert(s) detected - Click for details` : 'Click for system details'}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'transparent';
      }}
    >
      {renderIcon()}
      
      {/* Alert count badge for multiple alerts */}
      {hasAlerts && server.ninjaDetail.ninjaData.alerts.length > 1 && (
        <span
          style={{
            position: 'absolute',
            top: '-2px',
            right: '-2px',
            backgroundColor: '#C82333',
            color: 'white',
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '50%',
            width: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '16px',
          }}
        >
          {server.ninjaDetail.ninjaData.alerts.length}
        </span>
      )}
    </button>
  );
};

export default DeviceInfoIcon;
export { DeviceInfoIconAlt };